import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { authGuard } from '@/core/guards/auth.guard';

export const appRoutes: Routes = [
    { path: 'login', loadComponent: () => import('@/features/auth/pages/login/login.component').then((c) => c.LoginComponent) },
    { path: 'change-password', loadComponent: () => import('@/features/auth/pages/change-password/change-password.component').then((c) => c.ChangePasswordComponent) },
    { path: 'forgot-password', loadComponent: () => import('@/features/auth/pages/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent) },
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            // {
            //     path: '',
            //     loadComponent: () => import('@/pages/dashboards/ecommerce/ecommercedashboard').then((c) => c.EcommerceDashboard),
            //     data: { breadcrumb: 'Dashboard' }
            // },
            {
                path: '',
                loadComponent: () => import('@/features/document/pages/document-management-request/request-document-list/request-document-list').then((c) => c.RequestDocumentList),
                data: { breadcrumb: 'สร้างคำขอจัดการเอกสาร' }
            },
            {
                path: 'documents',
                loadChildren: () => import('@/features/document/document-routing-module').then((m) => m.DocumentRoutingModule)
                // data: { breadcrumb: 'Document' }
            },
            {
                path: 'user-accounts',
                loadChildren:() => import('@/features/user-accounts/user-accounts-routing-module').then((m) => m.UserAccountsRoutingModule),
                data: { breadcrumb: 'User Accounts' }
            },
            {
                path: 'roles',
                loadChildren:() => import('@/features/roles/roles-routing-module').then((m) => m.RolesRoutingModule),
                data: { breadcrumb: 'Roles' }
            } 
        ]
    }

    // { path: '**', redirectTo: '/notfound' }
];
